export const IF_SOURCE_HANDLES = {
  true: 'if-true',
  false: 'if-false',
} as const;
